import '../styles/main.css';
import { initNSCMemberPrice } from './modules/nsc-member-price';
import { initInstructorProduct } from './modules/instructor-product';
import { facetWPScrollRefresh } from './modules/facetwp-scroll';
import { initDefensiveDrivingNotice } from './modules/defensive-driving-notice';
import { initWelcomeNotice } from './modules/welcome-notice';
import { initNoCacheLinks } from './modules/no-cache-links';

document.addEventListener('DOMContentLoaded', () => {
    initNoCacheLinks();
    initNSCMemberPrice();
    initInstructorProduct();
    facetWPScrollRefresh();
    initDefensiveDrivingNotice();
    initWelcomeNotice();

    const initialUrl = window.location.href;
    // Re-add the listeners for checking the NSC member price and instructor number when Facetwp refreshes results.
    document.addEventListener( 'facetwp-loaded', () => {
        initNoCacheLinks();

        if ( window.location.href !== initialUrl ) {
            setTimeout( () => {
                initNSCMemberPrice();
                initInstructorProduct();
            }, 1000 );
        }
    } );
});
